var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPengalamanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 11.1663C10.5775 11.1663 12.6668 9.077 12.6668 6.49967C12.6668 3.92235 10.5775 1.83301 8.00016 1.83301C5.42283 1.83301 3.3335 3.92235 3.3335 6.49967C3.3335 9.077 5.42283 11.1663 8.00016 11.1663Z",
    stroke: "#505050"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90074 10.5L4.47616 12.0487C4.05727 13.5765 3.84782 14.3405 4.12731 14.7587C4.22527 14.9053 4.35667 15.0229 4.50915 15.1005C4.94423 15.3221 5.61601 14.9721 6.95953 14.272C7.4066 14.0391 7.63013 13.9226 7.8676 13.8973C7.95567 13.8879 8.04433 13.8879 8.1324 13.8973C8.36987 13.9226 8.5934 14.0391 9.04047 14.272C10.384 14.9721 11.0558 15.3221 11.4909 15.1005C11.6433 15.0229 11.7747 14.9053 11.8727 14.7587C12.1522 14.3405 11.9427 13.5765 11.5239 12.0487L11.0993 10.5",
    stroke: "#505050",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPengalamanIcon);
export default __webpack_public_path__ + "static/media/pengalaman_icon.ddd198160eeafa4c8002e8b413646b12.svg";
export { ForwardRef as ReactComponent };